import React from 'react';
import LoadingItem from "../loading-item/loading-item.component";


const LoadingContainer = () => {
    return(
        <>
            <LoadingItem/>
            <LoadingItem/>
            <LoadingItem/>
        </>
    );
};

export default LoadingContainer;
